import type { GameSave } from '@/app/services';
import type { Panel } from '@/ui/components/NavButtons';

type SavedPanel = GameSave['lastSession']['panel'];
type Saved = { panel: SavedPanel; panelParams?: Record<string, string> };

/** Catalog tabs a resumed Mua sắm may open on (CatalogSheet's tab ids). */
const CATALOG_TABS = ['furniture', 'decor', 'stock', 'plants', 'wallfloor', 'themes'] as const;
export type CatalogTab = (typeof CATALOG_TABS)[number];

/**
 * Quick resume (ux-screens §7.1): only "durable" panels come back after a reload: Mua sắm (with its tab),
 * Gợi ý, Đơn hàng, Hòm thư. Menus, modals, dialogue and photo mode never do.
 */
export function toSavedPanel(panel: Panel, catalogTab?: CatalogTab): Saved {
  switch (panel) {
    case 'catalog':
      return { panel: 'catalog', ...(catalogTab ? { panelParams: { tab: catalogTab } } : {}) };
    case 'stock':
      return { panel: 'catalog', panelParams: { tab: catalogTab ?? 'stock' } };
    case 'tasks':
    case 'orders':
      return { panel };
    case 'mail':
      return { panel: 'mailbox' };
    default:
      return { panel: 'none' };
  }
}

/** The panel (and catalog tab) to reopen at boot; `none` for anything that is not durable. */
export function fromSavedPanel(saved: Saved): { panel: Panel; catalogTab?: CatalogTab } {
  switch (saved.panel) {
    case 'catalog': {
      const tab = CATALOG_TABS.find((x) => x === saved.panelParams?.tab);
      return { panel: tab === 'stock' ? 'stock' : 'catalog', ...(tab ? { catalogTab: tab } : {}) };
    }
    case 'tasks':
    case 'orders':
      return { panel: saved.panel };
    case 'mailbox':
      return { panel: 'mail' };
    default:
      return { panel: 'none' };
  }
}
